import { store } from "@/apps/admin-console/store";
import { Store } from "vuex";
import { IVuexState } from "@/apps/admin-console/shared-models/IVuex";
import { getAdminAccount } from "@/apps/admin-console/services/admin-accounts.service";

export default async function useAdminAccountPersistState(): Promise<boolean> {
  const vuexStore = store as unknown as Store<IVuexState>;
  const adminJwt = sessionStorage.getItem("PJ_AdminJwt");

  if (!adminJwt) {
    return false;
  }

  await store.dispatch("admin/setAdminJwt", adminJwt);

  const adminAccountId = sessionStorage.getItem("PJ_admin");
  if (!vuexStore.state.admin?.adminAccount && adminAccountId) {
    try {
      const response = await getAdminAccount(adminAccountId);
      await store.dispatch("admin/setAdminState", response.data);
      return true;
    } catch {
      return false;
    }
  }

  return true;
}
